/**
 * Curated presets for the secondary theme dimensions surfaced on the
 * Branding page. Each list is grouped by what it visually controls so a
 * tenant admin doesn't have to think in terms of CSS tokens.
 *
 * NULL on the tenant means "use the default declared in tokens.css".
 */
export type ColorPreset = { name: string; hex: string }

// --bk-card - every card / modal / popover / dropdown surface.
export const CARD_SURFACE_PRESETS: ColorPreset[] = [
  { name: 'Pure White',  hex: '#ffffff' }, // current default
  { name: 'Ivory',       hex: '#fffdf7' },
  { name: 'Cool White',  hex: '#fbfcfe' },
  { name: 'Warm White',  hex: '#fdfbf7' },
  { name: 'Off-white',   hex: '#f9fafb' },
  { name: 'Porcelain',   hex: '#f6f7f9' },
]

// --bk-text - heading + body text. Stays in the dark-near-black family
// so combining with any preset card surface keeps WCAG-AA readability.
export const TEXT_COLOR_PRESETS: ColorPreset[] = [
  { name: 'Charcoal',    hex: '#161a26' }, // current default
  { name: 'Ink Black',   hex: '#0b0d12' },
  { name: 'Slate',       hex: '#1e293b' },
  { name: 'Graphite',    hex: '#1f2937' },
  { name: 'Warm Brown',  hex: '#1e1b15' },
  { name: 'Navy',        hex: '#0f172a' },
]

// --bk-sidebar-fg - inactive nav-label colour in the sidebar. Sits
// between text + muted-foreground; pick something readable but quiet.
export const SIDEBAR_TEXT_PRESETS: ColorPreset[] = [
  { name: 'Cool Gray',   hex: '#535d6c' }, // current default
  { name: 'Slate Gray',  hex: '#475569' },
  { name: 'Warm Gray',   hex: '#57534e' },
  { name: 'Muted Black', hex: '#374151' },
  { name: 'Soft Gray',   hex: '#6b7280' },
  { name: 'Stone',       hex: '#78716c' },
]

// --bk-secondary - neutral / "secondary" button background. Same family
// as sidebar text but a touch darker so the white text on top reads.
export const SECONDARY_COLOR_PRESETS: ColorPreset[] = [
  { name: 'Cool Gray',   hex: '#6b7280' }, // current default
  { name: 'Slate',       hex: '#475569' },
  { name: 'Warm Gray',   hex: '#57534e' },
  { name: 'Stone',       hex: '#78716c' },
  { name: 'Steel',       hex: '#64748b' },
  { name: 'Charcoal',    hex: '#374151' },
]

export const DEFAULT_CARD_HEX      = CARD_SURFACE_PRESETS[0].hex
export const DEFAULT_TEXT_HEX      = TEXT_COLOR_PRESETS[0].hex
export const DEFAULT_SIDEBAR_HEX   = SIDEBAR_TEXT_PRESETS[0].hex
export const DEFAULT_SECONDARY_HEX = SECONDARY_COLOR_PRESETS[0].hex
